<template>
    <div class="modal_card" v-if="!loading">
        <div class="header">
            <h4 class="title">
              {{ translate("soft_version_history") }}
            </h4>
            <h4 class="title">
                {{ device.name2 }} ({{ device.fid }})
            </h4>
        </div>

      <div class="params">

        <div
            v-for="(param,key) in params"
            :key="key"
        >
          <div>
            <p>{{ get_date(param.time) }}:</p>
            <pre v-if="typeof(param.data) === 'string' && param.data.indexOf('{') > -1 ">{{ JSON.parse(param.data) }}</pre>
            <pre v-else>{{ param.data }}</pre>
          </div>
        </div>

      </div>


        <div class="modal_clients__footer">
            <div class="text-center">

                <span
                    class="btn btn-danger btn-fill btn-wd marginButton"
                    @click.prevent="close"
                >
                    {{ translate('close_modal') }}
                </span>

            </div>
        </div>
    </div>

    <div v-else style="height: 100%" >
        <div class="spinner">
            <scale-loader />
        </div>
    </div>
</template>
<script>

export default {
  name: "VersionHistory",
  props: ['device'],
  data () {
    return {
      params: {},
      loading: false
    }
  },

  created() {
    this.init()
  },

  methods: {
    close(){
      this.$emit('close')
    },
    init(){
      this.loading = true
      this.$http.v1.getDeviceVersionHistory( this.device.id,(response) => {

        let params = []
        Object.keys(response.data).forEach(function(key) {
          params.push({'time': key, 'data': response.data[key]})
        });
        this.params = params.sort((a, b) => a.time < b.time ? 1 : -1)

        this.loading = false
      })
    },

  }
}
</script>
<style lang="scss" scoped>
.modal_card{
  width: 100%;
  border-radius: 3px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  color: #252422;
  position: relative;
  border: 1px solid #ccc;
  min-height: 85px;
  background-color: #f8f8f8;
  padding: 10px;

  .header{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 15px;
    .title{
      margin: 0;
    }

  }

  .params{
    height: 500px;
    overflow-y: auto;
    &::-webkit-scrollbar{
      width: 10px;
    }
  }
}

</style>
